import { billOfMaterialsIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deleteBillOfMaterials = {
  name: "deleteBillOfMaterials" as const,
  input: z.object({ billOfMaterialsId: billOfMaterialsIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
